module.exports = __webpack_public_path__ + "img/1970East-061_WEB-min.06b8864a.jpg";